import { z } from "zod";
import { isValidTime } from "../../../../../../../utils/timeValidate";

export const schema = z
  .object({
    unidade: z.string().min(1, { message: "Unidade é obrigatória" }),
    dia_semana: z.array(z.enum(["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"]))
      .nonempty("Selecione pelo menos um dia da semana"),
    intervalo_ativo: z.boolean().default(false),
    hora_inicio_manha: z.string().min(5, { message: "Hora de início da manhã é obrigatória" }),
    hora_fim_manha: z.string().nullable(),
    hora_inicio_tarde: z.string().nullable(),
    hora_fim_tarde: z.string().min(5, { message: "Hora de fim da tarde é obrigatória" }),
  })
  .superRefine((data, ctx) => {
    if (data.intervalo_ativo) {
      if (data.hora_fim_manha.length < 5) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Horário de intervalo deve ser preenchido",
          path: ["hora_fim_manha"],
        });
      } else {
        if (!isValidTime(data.hora_inicio_manha)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Horário de início da manhã deve ser válido",
            path: ["hora_inicio_manha"],
          });
        }
      }

      if (data.hora_inicio_tarde.length < 5) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Horário de intervalo deve ser preenchido",
          path: ["hora_inicio_tarde"],
        });
      } else {
        if (!isValidTime(data.hora_fim_tarde)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Horário de fim da tarde deve ser válido",
            path: ["hora_fim_tarde"],
          });
        }
      }

      if (!isValidTime(data.hora_inicio_manha)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Horário de início da manhã deve ser válido",
          path: ["hora_inicio_manha"],
        });
      }

      if (!isValidTime(data.hora_fim_tarde)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Horário de fim da tarde deve ser válido",
          path: ["hora_fim_tarde"],
        });
      }
    }
  });
